<div>
    <div class="image">
        <div class="content" style="height: 500px; width: 1000px;background: white;margin: 0 auto;">
                
        </div>
    </div> 
</div>
